import { render, staticRenderFns } from "./AssistantSetup.vue?vue&type=template&id=0ec63554&scoped=true&"
import script from "./AssistantSetup.vue?vue&type=script&lang=js&"
export * from "./AssistantSetup.vue?vue&type=script&lang=js&"
import style0 from "./AssistantSetup.vue?vue&type=style&index=0&id=0ec63554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec63554",
  null
  
)

component.options.__file = "AssistantSetup.vue"
export default component.exports